export default "__VITE_ASSET__Br4kNHrW__"